import { IWritingIssue } from "@edgetier/watchtower-types";

/**
 * Format a message with a custom syntax for writing issues that the Markdown comopnent will recognise and highlight.
 * @param writingIssues The writing issues for a given message.
 * @param message       The message that contains writing issues.
 * @returns A message with a custom markdown syntax for writing issues.
 */
export const formatWritingIssueMessage = (writingIssues: IWritingIssue[], message: string) => {
    // Split the message by character so we can use the writing issue start/end index to alter the string
    // without messing up the indexes of subsequent writing issues.
    const splitMessage = message.split("");
    // The Markdown component accepts a custom syntax: "**[someClassName]some text**" that allows class name(s)
    // to be added to that section of writing. This is used to highlight spelling and grammar issues.
    writingIssues.forEach(({ description, startIndex, endIndex, writingIssueType }) => {
        splitMessage[
            startIndex
        ] = ` **issueStart[writing-issue writing-issue--${writingIssueType.toLowerCase()},${description}]${
            splitMessage[startIndex]
        }`;

        // Avoid using an index higher than message character array
        const writingIssueEndIndex = Math.min(endIndex, splitMessage.length - 1);

        splitMessage[writingIssueEndIndex] = `${splitMessage[writingIssueEndIndex]}issueEnd** `;
    });
    return splitMessage.join("");
};
